var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import LayerPoisGroups from './Layer-pois-groups';
import LayerPoisContent from './Layer-pois-content';

var LayerPois = function (_Component) {
    _inherits(LayerPois, _Component);

    function LayerPois(props) {
        _classCallCheck(this, LayerPois);

        var _this = _possibleConstructorReturn(this, (LayerPois.__proto__ || Object.getPrototypeOf(LayerPois)).call(this, props));

        _this.onClickGroups = function (idTipo) {
            if (_this.state.groupOpen === idTipo) {
                _this.setState({
                    groupOpen: ""
                });
            } else {
                _this.setState({
                    groupOpen: idTipo
                });
            }
        };

        _this.onClickWithOutGroups = function (idTipo) {
            if (_this.state.withOutGroupPoiOpen === idTipo) {
                _this.setState({
                    withOutGroupPoiOpen: ""
                });
            } else {
                _this.setState({
                    withOutGroupPoiOpen: idTipo
                });
            }
        };

        _this.groupsPois = function () {
            _this.setState({
                isShowGroups: !_this.state.isShowGroups
            });
            // if ($("#sidebar-map-content-wrap").css("display") === "none") {
            //     $("#sidebar-map-content-wrap").css("display", "block");
            //     $("#groups").css("display", "none");
            //     return;
            // } else {
            //     $("#sidebar-map-content-wrap").css("display", "none");
            //     $("#groups").css("display", "block");
            //     return;
            // }
        };

        _this.state = {
            value: [],
            devices: 'devicesData',
            valueSearchFilter: '',
            isShowGroups: true,
            oldAssetsIOTImei: "",
            groupOpen: "",
            withOutGroupPoiOpen: ""
        };
        return _this;
    }

    _createClass(LayerPois, [{
        key: 'renderA',
        value: function renderA() {
            var _this2 = this;

            return React.createElement(
                'div',
                { id: 'groups' },
                this.props.groupsPois.map(function (item, i) {
                    return item.poisInfo !== null && item.poisInfo.length > 0 && React.createElement(LayerPoisGroups, { centerMap: _this2.props.centerMap, withOutGroupPoiOpen: _this2.state.withOutGroupPoiOpen, onClickWithOutGroups: _this2.onClickWithOutGroups, onClickGroups: _this2.onClickGroups, centerMapWihtOutFollow: _this2.props.centerMapWihtOutFollow, groupOpen: _this2.state.groupOpen, key: item.idTipo + i, poi: item, handleCheckboxPoisChange: _this2.props.handleCheckboxPoisChange, handleCheckboxPoiChange: _this2.props.handleCheckboxPoiChange });
                })
            );
        }
    }, {
        key: 'renderB',
        value: function renderB() {
            var _this3 = this;

            return React.createElement(
                'div',
                { id: 'sidebar-map-content-wrap', className: 'sidebar-map-content-wrap' },
                React.createElement(
                    'div',
                    { className: 'sidebar-map-content' },
                    this.props.groupsPois.map(function (item) {
                        return item.poisInfo !== null && item.poisInfo.map(function (item2, i) {
                            return React.createElement(LayerPoisContent, { centerMap: _this3.props.centerMap, withOutGroupPoiOpen: _this3.state.withOutGroupPoiOpen, onClickWithOutGroups: _this3.onClickWithOutGroups, key: item2.idTipo + i + 70, centerMapWihtOutFollow: _this3.props.centerMapWihtOutFollow, saveOldIOTImei: _this3.props.saveOldIOTImei, oldAssetsIOTImei: _this3.props.oldAssetsIOTImei, isOpenDeviceContent: _this3.props.isOpenDeviceContent, centerDevice: _this3.props.centerDevice, setLatLng: _this3.props.setLatLng, valueFilter: _this3.props.valueFilter, poiContent: item2, filter: _this3.props.filter, id: item2.idTipo + i + 33, handleCheckboxPoiChange: _this3.props.handleCheckboxPoiChange });
                        });
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            // console.log("render - layerPois")
            return React.createElement(
                'div',
                { style: { height: "100%" } },
                React.createElement(
                    'div',
                    { className: 'map-search-right' },
                    React.createElement(
                        'div',
                        { id: 'list-view-header-wrap' },
                        React.createElement(
                            'span',
                            { className: 'map-mobile-filter select-box' },
                            this.props.child[4]
                        ),
                        React.createElement(
                            'div',
                            { onClick: this.props.click.bind(this), style: { top: "10px", left: "81.4%", height: "44px", width: "17%", lineHeight: "1.3" }, id: 'list-view-header', className: 'map-accordion-group-filter lists clearfix' },
                            React.createElement('span', { className: 'icon-colapse_down caret-style', style: { transform: "rotate(90deg)", marginRight: "5px" } })
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'map-search-right' },
                    React.createElement(
                        'div',
                        { id: 'list-view-header-wrap' },
                        React.createElement(
                            'span',
                            { className: 'map-mobile-filter select-box' },
                            this.props.child[5]
                        ),
                        React.createElement(
                            'div',
                            { id: 'list-view-header', className: 'map-accordion-group-filter lists clearfix', onClick: this.groupsPois },
                            React.createElement('span', { className: 'icon-organigram' })
                        )
                    )
                ),
                this.state.isShowGroups ? this.renderA() : this.renderB()
            );
        }
    }]);

    return LayerPois;
}(Component);

export default LayerPois;